
<template>
  <div class="page-wrapper">
    <div class="wrapper max30 ">
      项目名称：
      <span style="position: relative;float:left">
      <Select class="input" v-model="projectFid">
        <!--<Option value="">请选择</Option>-->
        <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
      </Select>
        </span>
      <Button type="primary" style="margin-left: 20px" @click="ok">确定</Button>
      <span style="float:right;margin-left: 500px"><strong>总人数：{{this.amount}}</strong></span>
    </div>
    <div id="container" class="my-map-contain"></div>
  </div>
</template>

<script>
  import {getProjects} from "../../../api/common"
  import {getPersonLonAndLat, getProjectLonAndLat} from "../../../api/reporter"
  export default {
    name: "thermogram",
    data(){
      return {
        projectList:[],
        projectFid: '',
        personLonLatVos: [],
        project: {},
        amount: null
      }
    },
    components:{

    },
    methods:{
      isSupportCanvas(){
        var elem = document.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
      },
      ok(){
        if(this.projectFid === null){
          this.$Message.info('所选项目为空')
          return
        }
        this.getProjectLonAndLat()
        this.getPersonLonAndLat()
      },
      getPersonLonAndLat(){
        var params = {
          projectFid: this.projectFid
        }
        if(!this.isSupportCanvas()){
          this.$Message.warning('热力图目前只支持有canvas支持的浏览器,您所使用的浏览器不能使用热力图功能~')
          return
        }
        getPersonLonAndLat(params).then(res => {
          if(!res.data){
            return
          }
          this.personLonLatVos = res.data
          let allcount = 0
          this.personLonLatVos.forEach(item => {
            allcount += item.count
          })
          this.amount = allcount
          this.createMap()
        })
      },
    getProjectLonAndLat(){
      var params = {
        projectFid: this.projectFid
      }
      getProjectLonAndLat(params).then(res => {
        if(!res.data){
          return
        }
        this.project = res.data
      })
    },
      createMap(){
        const _self= this
        var map = new BMap.Map("container")
        // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(this.project.projectLon, this.project.projectLat), 12)
        // 设置地图显示的城市 此项是必须设置的
        //map.setCurrentCity("北京");
        // 开启鼠标滚轮缩放
        map.enableScrollWheelZoom(true);
        //加标注
        var marker = new BMap.Marker(new BMap.Point(this.project.projectLon, this.project.projectLat));
        map.addOverlay(marker);
        var points = []
        points = this.personLonLatVos
        var heatmapOverlay = new BMapLib.HeatmapOverlay({"radius":20});
        map.addOverlay(heatmapOverlay);
        heatmapOverlay.setDataSet({data:points,max:2});
        heatmapOverlay.show();
        var gradient = {
          0.45: "rgb(0,0,255)",
          0.55: "rgb(0,255,255)",
          0.65: "rgb(0,255,0)",
          0.95: "yellow",
          1: "rgb(255,0,0)"
        };
        var colors = document.querySelectorAll("input[type='color']");
        colors = [].slice.call(colors,0);
        colors.forEach(function(ele){
          gradient[ele.getAttribute("data-key")] = ele.value;
        });
        heatmapOverlay.setOptions({"gradient":gradient});
      },
      getProjects(){
        getProjects().then(res => {
          if(!res.data){
            return
          }
          this.projectList = res.data
          if(this.projectList && this.projectList.length>0){
            this.projectFid = this.projectList[0].value
            this.getProjectLonAndLat()
            this.getPersonLonAndLat()
          }
        }).catch(error => {
        })
      }
    },

    created(){
      this.getProjects()
    }
  }
</script>

<style scoped>
  .input{
    display: inline-block;
    width: 250px;
    margin-right: 20px;
  }
  .wrapper{
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
  }
  .my-map-contain{
    height: 600px;
    width: 100%;
    border: solid 1px #dddee1;
    border-radius: 4px;
    margin-top: 20px;
  }
</style>
